// title  标题
// tabbar: true 底部导航栏展示
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader: true 没有顶部
export default [
  {
    path: "/shop/goodsList",
    name: "shop.goodsList",
    meta: {
      title: "商品列表",
      unpull: true,
      noheader: true,
    },
    component: () => import("./GoodsList"),
  },
  {
    path: "/shop/detail",
    name: "shop.detail",
    meta: {
      title: "商品详情",
      unpull: true,
      noheader: true,
    },
    component: () => import("./ShopDetail"),
  },
  {
    path: "/premium",
    name: "premium",
    meta: {
      title: "云手机补差价",
      unpull: true,
      noheader: true,
    },
    component: () => import("./Premium"),
  },
];
